import { useContext } from 'react';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import StaticContext from '~/context/srp/StaticContext';

export default function useGetShowEvBanner() {
  const { hasEVBannerUtm } = useContext(StaticContext);
  const { appliedFilters } = useContext(AppliedFiltersContext);

  const onlyHasPriceFilterAndMaxUnder30k = Boolean(
    Object.keys(appliedFilters).length === 1 &&
      appliedFilters.price &&
      appliedFilters.price.max &&
      appliedFilters.price.max <= 30000
  );
  const evOrHybridFilters = ['Electric', 'Hybrid', 'Plug-In Hybrid'];
  const hasEVOrHybridFilter = Boolean(
    appliedFilters.fuelTypes?.some(fuelType =>
      evOrHybridFilters.includes(fuelType)
    )
  );

  return (
    hasEVBannerUtm || onlyHasPriceFilterAndMaxUnder30k || hasEVOrHybridFilter
  );
}
